import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import MerchantLayout from '../../../layout/MerchantLayout';
import MerchantRecoverPasswordEmailView from './MerchantRecoverPasswordEmailView';
import MerchantRecoverPasswordSuccessView from './MerchantRecoverPasswordSuccessView';
import { merchantForgotPassword } from '../../../services/c2dcrm';
import { isEmail } from '../../../utils/validations';
import { useSnackbar } from '../../Context/SnackbarContext';

const useStyles = makeStyles({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emailWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '40px',
  },
});

const MerchantRecoverPassword: React.FC = () => {
  const classes = useStyles();
  const [currentStep, setCurrentStep] = useState<1 | 2>(1);
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string>();
  const { openSnackbar } = useSnackbar();

  const handleSubmit = async (emailValue: string) => {
    try {
      if (!isEmail(emailValue)) {
        setError('Must be a valid email.');
        return;
      }

      const res = await merchantForgotPassword(emailValue);

      if (res) {
        window.scrollTo(0, 0);
        setCurrentStep(2);
      }
    } catch (e) {
      openSnackbar('Error: Something went wrong while sending the e-mail.');
    }
  };

  const onNext = (emailValue: string) => {
    setEmail(emailValue);
    handleSubmit(emailValue);
  };

  return (
    <MerchantLayout>
      {currentStep === 2 && (
        <div className={classes.emailWrapper}>
          <Typography variant="h3" color="textPrimary">
            {email}
          </Typography>
        </div>
      )}

      <div className={classes.root}>
        {currentStep === 1 && (
          <MerchantRecoverPasswordEmailView
            onNext={onNext}
            error={error}
            clearError={() => setError('')}
          />
        )}
        {currentStep === 2 && (
          <MerchantRecoverPasswordSuccessView onSendAgain={() => setCurrentStep(1)} />
        )}
      </div>
    </MerchantLayout>
  );
};

export default MerchantRecoverPassword;
